var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBuysell4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 194,
    height: 166,
    viewBox: "0 0 194 166",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "OBJECTS"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    d: "M105.553 16.1815L106.233 25.4007C106.347 26.7339 105.808 28.0671 104.843 28.9749L95.1136 38.0522C94.4045 38.7047 93.44 39.0167 92.4755 38.8749L84.5896 37.8537C82.6039 37.57 81.1856 35.6978 81.6111 33.7405C82.2351 30.8754 84.6747 27.8402 92.9578 30.4783C92.9578 30.4783 95.3122 26.9041 97.2128 25.6843C97.2128 25.6843 94.291 24.0107 94.2059 23.0462C94.2059 23.0462 90.5466 26.507 85.3271 27.9253L87.9085 10.5081L95.1136 11.9265L105.553 16.1815Z",
    fill: "#E8A370"
  }), /*#__PURE__*/React.createElement("g", {
    id: "<Group>_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>_2",
    d: "M120.786 46.4488C120.786 55.8949 113.126 63.5539 103.652 63.5539C94.2059 63.5539 86.5469 55.8949 86.5469 46.4488C86.5469 36.9743 94.2059 29.3153 103.652 29.3153C113.126 29.3153 120.786 36.9743 120.786 46.4488Z",
    fill: "#EA9F26"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>_3",
    d: "M117.75 46.4488C117.75 55.2424 110.602 62.3909 101.808 62.3909C93.0145 62.3909 85.8661 55.2424 85.8661 46.4488C85.8661 37.6267 93.0145 30.5067 101.808 30.5067C110.602 30.5067 117.75 37.6267 117.75 46.4488Z",
    fill: "#EAC049"
  }), /*#__PURE__*/React.createElement("g", {
    id: "<Group>_3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M104.702 57.2281V60.4052H101.865V57.3132C99.0566 57.143 96.3618 56.2636 94.8016 55.0439L96.3618 51.5831C97.7801 52.6327 99.8225 53.3986 101.865 53.5972V48.8599C98.7162 48.094 95.1987 47.0445 95.1987 42.988C95.1987 39.9811 97.383 37.3714 101.865 36.8608V33.7121H104.702V36.8041C106.829 36.9743 108.9 37.5416 110.46 38.5344L109.042 42.0519C107.595 41.2293 106.12 40.747 104.702 40.5768V45.3992C107.85 46.1367 111.311 47.1863 111.311 51.186C111.311 54.1361 109.155 56.6891 104.702 57.2281ZM101.865 44.69V40.6619C100.361 41.0023 99.7658 41.825 99.7658 42.7611C99.7658 43.7539 100.617 44.2929 101.865 44.69ZM106.744 51.5264C106.744 50.5336 105.921 49.9946 104.702 49.5691V53.4837C106.12 53.1717 106.744 52.4341 106.744 51.5264Z",
    fill: "#CC8215"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>_4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M103.453 56.604V59.7811H100.617V56.6891C97.8084 56.5189 95.1136 55.6396 93.5534 54.4198L95.1136 50.959C96.5319 52.0086 98.5743 52.7745 100.617 52.9731V48.2358C97.468 47.4699 93.9506 46.4204 93.9506 42.3639C93.9506 39.3571 96.1348 36.7757 100.617 36.2651V33.088H103.453V36.2084C105.581 36.3786 107.652 36.9459 109.212 37.9387L107.794 41.4278C106.347 40.6052 104.872 40.123 103.453 39.9528V44.7751C106.602 45.5126 110.063 46.5622 110.063 50.5619C110.063 53.5121 107.907 56.0651 103.453 56.604ZM100.617 44.0659V40.0379C99.1133 40.3783 98.5176 41.2009 98.5176 42.137C98.5176 43.1298 99.3686 43.6688 100.617 44.0659ZM105.496 50.9023C105.496 49.9095 104.673 49.3705 103.453 48.945V52.8596C104.872 52.5476 105.496 51.8101 105.496 50.9023Z",
    fill: "#EA9F26"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "<Path>_4",
    d: "M125.438 37.3147C125.438 37.3147 117.523 44.5199 109.552 28.2657C109.552 28.2657 108.162 27.4147 106.233 26.0815C102.829 23.7271 97.8368 19.9543 96.1632 16.8907C96.1632 16.8907 91.9933 13.3449 89.9792 14.7065C89.9036 14.7632 89.828 14.8294 89.7523 14.905C89.7523 14.905 89.7429 14.9239 89.7239 14.9618C89.4403 15.7277 87.2277 22.1385 87.6248 27.1594C87.6815 27.9821 87.8234 28.7764 88.0503 29.4855C88.1449 29.7692 88.2489 30.0434 88.3623 30.3082C88.3623 30.3082 88.9013 31.1308 89.9792 32.2655C91.2841 33.6554 93.4116 35.4709 96.3901 36.8325C97.4113 37.2864 98.4893 37.6835 99.709 37.9672C99.709 37.9672 109.893 40.3216 108.474 46.5907C108.191 47.7253 107.453 48.7182 106.375 49.2004C105.439 49.6259 104.021 49.9379 101.95 49.7961L95.4824 48.9451C93.0712 48.6331 90.7452 47.9523 88.5609 46.9027C88.1449 46.7136 87.7005 46.515 87.2277 46.307C84.2208 44.917 80.4197 43.3852 78.4056 43.2717C78.4056 43.2717 65.3002 39.499 57.6128 29.8543L0 46.4488V6.65031C15.1478 6.22481 74.7747 4.32423 88.8729 0.35289C92.3053 -0.611578 95.9646 0.437991 98.4042 3.04773L118.8 25.2305C119.046 25.4953 119.254 25.7884 119.424 26.1099L120.587 28.2941L125.182 36.8609L125.438 37.3147Z",
    fill: "#F4B887"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>_5",
    opacity: 0.2,
    d: "M0 6.65027V10.8769C23.1472 7.87004 54.6627 7.35944 77.4979 2.39526C57.9532 4.9199 12.2261 6.30987 0 6.65027Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>_6",
    d: "M0 42.676V46.4488L57.6128 29.8542C57.8397 30.1568 58.0856 30.4499 58.3503 30.7336C58.322 30.3081 58.3503 29.8826 58.4922 29.4571C35.2598 31.4428 21.8991 34.1376 0 42.676Z",
    fill: "#E8A370"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>_7",
    d: "M125.182 36.8608C123.877 37.6267 122.941 37.258 122.941 37.258C120.53 35.1872 118.204 29.7408 118.204 29.7408C118.715 29.5422 119.651 28.9465 120.587 28.2941L125.182 36.8608Z",
    fill: "#F9DCC7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>_8",
    d: "M99.2552 40.4067C99.2552 40.4067 99.5389 45.4559 97.9503 48.0941C97.9503 48.0941 106.716 50.7605 107.056 45.3709C107.056 45.3709 107.538 40.7187 99.2552 40.4067Z",
    fill: "#F9DCC7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>_9",
    d: "M79.3417 22.6207C79.3417 22.6207 84.079 16.5502 90.9153 14.5646C90.9153 14.5646 84.7597 14.7631 79.3417 22.6207Z",
    fill: "#E8A370"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>_10",
    d: "M88.3624 30.3081C88.3624 30.3081 85.4973 27.0459 86.2632 20.4081C86.2632 20.4081 84.4761 27.3296 88.3624 30.3081Z",
    fill: "#E8A370"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>_11",
    d: "M93.8939 39.8393C93.8939 39.8393 94.8016 43.1015 91.5962 46.5906C91.5962 46.5906 92.8443 45.9098 93.8939 39.8393Z",
    fill: "#E8A370"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>_12",
    d: "M82.8024 34.7901C82.8024 34.7901 79.8239 37.5984 79.8807 41.5981C79.8807 41.5981 78.2921 39.0734 82.8024 34.7901Z",
    fill: "#E8A370"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>_13",
    d: "M109.552 28.2657C109.552 28.2657 111.027 25.5425 113.495 24.2376C113.495 24.2376 110.857 24.3227 109.552 28.2657Z",
    fill: "#E8A370"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>_14",
    d: "M96.1632 16.8906C96.1632 16.8906 98.0354 13.2313 101.212 13.7136C101.212 13.7136 97.9503 12.3236 96.1632 16.8906Z",
    fill: "#E8A370"
  })), /*#__PURE__*/React.createElement("path", {
    id: "<Path>_15",
    d: "M123.565 73.0851L93.5534 76.8295V72.4043L123.565 68.6599V73.0851Z",
    fill: "#998684"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>_16",
    opacity: 0.5,
    d: "M194 134.102C194 139.321 154.343 143.576 105.411 143.576C56.4781 143.576 16.8215 139.321 16.8215 134.102C16.8215 128.854 56.4781 124.627 105.411 124.627C154.343 124.627 194 128.854 194 134.102Z",
    fill: "#D1BC9D"
  }), /*#__PURE__*/React.createElement("g", {
    id: "<Group>_5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>_17",
    d: "M174.626 150.696C170.541 156.256 162.711 157.448 157.123 153.363C151.563 149.25 150.372 141.421 154.457 135.832C158.57 130.272 166.399 129.081 171.987 133.194C177.547 137.279 178.739 145.137 174.626 150.696Z",
    fill: "#EA9F26"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>_18",
    d: "M172.838 149.363C169.037 154.554 161.719 155.661 156.556 151.86C151.365 148.03 150.259 140.74 154.06 135.549C157.889 130.358 165.179 129.251 170.371 133.081C175.562 136.882 176.668 144.2 172.838 149.363Z",
    fill: "#EAC049"
  }), /*#__PURE__*/React.createElement("g", {
    id: "<Group>_6"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>_3",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M160.471 150.072L159.109 151.945L157.435 150.725L158.769 148.881C157.18 147.576 155.989 145.874 155.591 144.484L158.031 143.123C158.4 144.371 159.279 145.704 160.385 146.697L162.456 143.917C160.924 142.101 159.307 139.945 161.066 137.563C162.371 135.776 164.782 135.208 167.647 136.854L169.009 134.981L170.683 136.229L169.321 138.045C170.512 139.066 171.477 140.314 171.987 141.562L169.633 143.009C169.122 141.903 168.47 140.967 167.704 140.258L165.605 143.094C167.165 144.91 168.725 147.009 166.995 149.363C165.718 151.122 163.336 151.689 160.471 150.072ZM164.243 141.449L166.002 139.066C164.952 138.612 164.272 138.839 163.846 139.407C163.421 139.974 163.676 140.683 164.243 141.449ZM164.158 147.604C164.584 147.009 164.328 146.328 163.818 145.562L162.116 147.86C163.08 148.285 163.761 148.143 164.158 147.604Z",
    fill: "#CC8215"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>_7"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>_4",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M160.017 149.165L158.655 151.037L156.981 149.817L158.315 147.973C156.726 146.668 155.535 144.966 155.138 143.576L157.549 142.215C157.946 143.463 158.797 144.796 159.932 145.789L161.974 143.009C160.442 141.194 158.825 139.038 160.584 136.655C161.889 134.868 164.3 134.3 167.165 135.946L168.527 134.074L170.2 135.322L168.867 137.137C170.058 138.158 171.023 139.406 171.505 140.655L169.151 142.101C168.669 140.995 168.016 140.059 167.25 139.35L165.151 142.186C166.683 144.002 168.271 146.101 166.541 148.484C165.264 150.214 162.882 150.782 160.017 149.165ZM163.789 140.541L165.548 138.158C164.499 137.704 163.789 137.931 163.392 138.499C162.967 139.066 163.222 139.775 163.789 140.541ZM163.704 146.697C164.13 146.101 163.875 145.42 163.336 144.654L161.634 146.952C162.626 147.378 163.307 147.236 163.704 146.697Z",
    fill: "#EA9F26"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "<Path>_19",
    opacity: 0.5,
    d: "M178.313 164.284C178.313 165.022 172.328 165.617 164.953 165.617C157.606 165.617 151.62 165.022 151.62 164.284C151.62 163.575 157.606 162.979 164.953 162.979C172.328 162.979 178.313 163.575 178.313 164.284Z",
    fill: "#D1BC9D"
  }), /*#__PURE__*/React.createElement("g", {
    id: "<Group>_8"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>_9"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>_10"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>_20",
    d: "M87.9936 138.158L48.5922 134.102L48.4504 130.953L87.9936 130.046V138.158Z",
    fill: "#605858"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>_21",
    d: "M153.01 93.7645L126.884 92.4312L95.8228 92.7149L87.9936 91.1831V97.2536L128.104 96.1189L128.388 132.06L132.274 138.158L153.35 126.358L153.01 93.7645Z",
    fill: "#BFA6A2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>_22",
    d: "M88.1354 91.1831V134.13V135.01L72.8174 133.506L58.1802 132.116L49.0461 131.209L49.0744 92.9986L88.1354 91.1831Z",
    fill: "#F2DFDF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>_23",
    d: "M130.572 93.1971L153.01 93.7645L153.776 89.7364L147.734 70.8725L141.578 83.978L140.273 87.2969L130.572 93.1971Z",
    fill: "#E5CFCF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>_24",
    d: "M98.6027 92.6298L98.546 129.421L132.274 136.683L132.246 91.4668L98.6027 92.6298Z",
    fill: "#E5CFCF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>_25",
    d: "M83.7953 92.3178L98.9431 93.0553L141.153 92.6298V91.1831L83.7953 92.3178Z",
    fill: "#605858"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>_26",
    d: "M152.386 63.1L75.1434 73.4539L93.3265 85.9636L98.6027 88.7435L138.543 87.467L152.386 63.1Z",
    fill: "#B08952"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>_27",
    d: "M147.791 72.0639L153.01 91.8639L158.882 91.7788L152.074 66.7877L147.791 72.0639Z",
    fill: "#998684"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>_28",
    d: "M51.7409 93.5942L85.242 91.41L84.9583 84.8573L67.144 73.7092L50.975 87.4103L51.7409 93.5942Z",
    fill: "#F2DFDF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>_29",
    d: "M51.7409 93.5943V93.3957V88.1762L67.5412 74.4751L65.4704 73.1702L48.8475 88.0911V93.5943H51.7409Z",
    fill: "#998684"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>_30",
    d: "M87.9936 92.7433V127.379V128.684V137.563L98.6027 136.4L98.9431 93.0553L87.9936 92.7433Z",
    fill: "#BFA6A2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>_31",
    d: "M87.9936 131.35L98.6878 128.968L132.274 130.556V132.031L126.913 136.683L87.9936 131.35Z",
    fill: "#998684"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>_32",
    d: "M126.232 141.364L87.9936 138.158V131.35L126.232 133.62V141.364Z",
    fill: "#605858"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>_33",
    d: "M128.218 101.395V122.245L116.19 121.677L115.339 121.649L103.312 121.082V101.395H128.218Z",
    fill: "#998684"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>_34",
    d: "M105.411 121.167V101.395H103.312V121.082",
    fill: "#383333"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>_35",
    d: "M159.932 93.7928L159.846 91.722L152.386 63.1L138.146 86.9848L138.259 90.247L140.529 87.0415L141.692 85.9069L152.131 67.1281L158.882 91.7788L153.01 91.8639V93.7645L159.932 93.7928Z",
    fill: "#F2DFDF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>_36",
    d: "M65.8675 69.7379L77.6397 73.5106L88.1638 76.9146L98.6027 88.7436L93.6102 86.4459L65.8675 69.7379Z",
    fill: "#B08952"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>_37",
    d: "M93.3549 92.3177L98.6027 92.6298V88.7435L93.3265 86.2756L93.3549 92.3177Z",
    fill: "#BFA6A2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>_38",
    d: "M98.6027 92.6298L140.756 91.1831V86.8713L98.6027 88.7435V92.6298Z",
    fill: "#E5CFCF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>_39",
    d: "M138.146 91.2682V88.6301L151.819 65.7949L152.329 67.9507L141.153 89.3676V92.6298L138.146 91.2682Z",
    fill: "#BFA6A2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>_40",
    d: "M42.465 93.8779L49.0744 93.5943V88.1479L65.2718 73.5106L83.7953 84.9424V92.3178H93.3549L93.3265 86.2757L65.8675 69.7379L42.465 90.559V93.8779Z",
    fill: "#E5CFCF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>_41",
    d: "M103.312 101.395L104.531 101.906H128.218V101.395H103.312Z",
    fill: "#383333"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>_42",
    d: "M89.8091 128.003L97.2128 126.868V97.6507H89.8091V128.003Z",
    fill: "#998684"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>_43",
    d: "M89.8091 125.762V128.003L97.2128 126.868V125.762H89.8091Z",
    fill: "#605858"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>_44",
    d: "M89.8091 97.6507V98.8988H96.4752V126.982L97.2128 126.868V97.6507H89.8091Z",
    fill: "#383333"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>_45",
    d: "M132.274 130.556L126.232 133.62V141.364L132.274 138.158V130.556Z",
    fill: "#605858"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>_46",
    d: "M116.814 101.906V121.677L115.963 121.649V101.906H116.814Z",
    fill: "#383333"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>_47",
    d: "M128.218 112.316L104.56 112.118L104.616 111.267L128.218 111.465V112.316Z",
    fill: "#383333"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>_48",
    d: "M72.8174 102.615V133.506L58.1801 132.116V102.615H72.8174Z",
    fill: "#998684"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>_49",
    d: "M60.6197 105.054H72.8174V102.615H58.1801V132.116L60.6197 132.343V105.054Z",
    fill: "#383333"
  })), /*#__PURE__*/React.createElement("path", {
    id: "<Path>_50",
    d: "M70.6048 88.7435C70.6048 91.3533 68.4773 93.4808 65.8675 93.4808C63.2294 93.4808 61.1019 91.3533 61.1019 88.7435C61.1019 86.1054 63.2294 83.9779 65.8675 83.9779C68.4773 83.9779 70.6048 86.1054 70.6048 88.7435Z",
    fill: "#998684"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>_51",
    d: "M62.7756 88.7435C62.7756 86.3891 64.4776 84.4602 66.6902 84.063C66.4254 84.0063 66.1512 83.9779 65.8675 83.9779C63.2294 83.9779 61.1019 86.1054 61.1019 88.7435C61.1019 91.3533 63.2294 93.4808 65.8675 93.4808C66.1512 93.4808 66.4254 93.4524 66.6902 93.3957C64.4776 92.9986 62.7756 91.0696 62.7756 88.7435Z",
    fill: "#605858"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>_11"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>_52",
    d: "M121.069 73.3972L93.5534 76.8295L95.9646 72.0923L123.565 68.6599L121.069 73.3972Z",
    fill: "#605858"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>_53",
    d: "M95.3122 75.9218L95.9646 72.0923L93.5534 76.8295L121.069 73.3971L121.41 72.7447L95.3122 75.9218Z",
    fill: "#383333"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>_12"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>_54",
    d: "M180.441 98.3031C184.072 101.395 184.497 106.813 181.405 110.444C178.342 114.075 172.895 114.501 169.264 111.409C165.662 108.317 165.208 102.87 168.3 99.2676C171.392 95.6367 176.838 95.2111 180.441 98.3031Z",
    fill: "#EA9F26"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>_55",
    d: "M179.476 99.4662C182.824 102.331 183.249 107.409 180.356 110.756C177.491 114.132 172.413 114.529 169.037 111.664C165.69 108.799 165.265 103.721 168.158 100.346C171.023 96.9699 176.101 96.5728 179.476 99.4662Z",
    fill: "#EAC049"
  }), /*#__PURE__*/React.createElement("g", {
    id: "<Group>_13"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>_5",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M179.334 107.976L180.554 109.026L179.618 110.104L178.427 109.082C177.462 110.104 176.242 110.87 175.25 111.068L174.427 109.338C175.306 109.139 176.271 108.6 177.008 107.891L175.193 106.331C173.86 107.295 172.328 108.288 170.768 106.955C169.605 105.991 169.349 104.289 170.597 102.416L169.406 101.395L170.342 100.289L171.505 101.31C172.271 100.544 173.179 99.9484 174.058 99.6647L174.938 101.367C174.143 101.65 173.491 102.048 172.952 102.53L174.796 104.118C176.101 103.154 177.632 102.161 179.164 103.466C180.299 104.43 180.583 106.104 179.334 107.976ZM173.604 104.969L172.044 103.636C171.704 104.345 171.817 104.827 172.186 105.14C172.555 105.452 173.037 105.31 173.604 104.969ZM177.803 105.338C177.434 104.998 176.952 105.14 176.384 105.48L177.888 106.756C178.228 106.104 178.171 105.622 177.803 105.338Z",
    fill: "#CC8215"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>_14"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>_6",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M178.682 108.26L179.902 109.281L178.966 110.387L177.803 109.366C176.81 110.387 175.59 111.125 174.626 111.323L173.803 109.593C174.654 109.395 175.618 108.856 176.356 108.146L174.54 106.615C173.236 107.551 171.675 108.572 170.115 107.239C168.981 106.246 168.697 104.572 169.973 102.7L168.754 101.65L169.69 100.572L170.881 101.594C171.619 100.828 172.526 100.204 173.406 99.9484L174.285 101.622C173.491 101.906 172.838 102.331 172.299 102.813L174.143 104.374C175.477 103.409 177.008 102.445 178.54 103.75C179.646 104.714 179.93 106.359 178.682 108.26ZM172.952 105.253L171.42 103.92C171.051 104.601 171.165 105.111 171.534 105.423C171.902 105.735 172.385 105.593 172.952 105.253ZM177.179 105.593C176.781 105.281 176.299 105.423 175.76 105.735L177.264 107.04C177.604 106.388 177.519 105.905 177.179 105.593Z",
    fill: "#EA9F26"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>_15"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>_56",
    d: "M40.8765 115.891C38.0398 119.72 32.6501 120.543 28.8206 117.706C24.9911 114.898 24.1685 109.508 27.0051 105.678C29.8134 101.821 35.2031 101.026 39.0326 103.835C42.8905 106.671 43.6848 112.061 40.8765 115.891Z",
    fill: "#EA9F26"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>_57",
    d: "M39.6567 114.983C37.0186 118.557 31.9977 119.323 28.4235 116.685C24.8493 114.047 24.0834 109.026 26.7215 105.452C29.3312 101.906 34.3805 101.14 37.9263 103.75C41.5005 106.388 42.2664 111.409 39.6567 114.983Z",
    fill: "#EAC049"
  }), /*#__PURE__*/React.createElement("g", {
    id: "<Group>_16"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>_7",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.1467 115.465L30.1822 116.742L29.0192 115.891L29.9553 114.642C28.8774 113.735 28.0264 112.572 27.7711 111.607L29.4447 110.671C29.7 111.522 30.2957 112.458 31.0616 113.139L32.4799 111.21C31.4304 109.962 30.3241 108.487 31.5438 106.842C32.4232 105.622 34.0968 105.225 36.0541 106.359L36.9902 105.083L38.1533 105.934L37.2172 107.182C38.0398 107.891 38.7206 108.742 39.0326 109.593L37.4157 110.586C37.0753 109.82 36.6215 109.196 36.1109 108.714L34.6642 110.671C35.7137 111.891 36.82 113.366 35.6286 114.983C34.7493 116.174 33.104 116.571 31.1467 115.465ZM33.7281 109.536L34.9195 107.891C34.2103 107.579 33.7281 107.721 33.4444 108.118C33.1607 108.515 33.3309 108.997 33.7281 109.536ZM33.6713 113.763C33.955 113.366 33.7848 112.884 33.416 112.345L32.253 113.933C32.9338 114.245 33.3877 114.132 33.6713 113.763Z",
    fill: "#CC8215"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>_17"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>_8",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.8063 114.841L29.8702 116.117L28.7071 115.266L29.6432 114.018C28.5369 113.111 27.7143 111.948 27.459 110.983L29.1043 110.047C29.3879 110.898 29.9836 111.834 30.7495 112.515L32.1679 110.586C31.1183 109.338 30.012 107.863 31.2034 106.217C32.1111 104.998 33.7564 104.601 35.7421 105.735L36.6782 104.459L37.8412 105.31L36.9051 106.558C37.7277 107.267 38.3802 108.118 38.7206 108.969L37.1037 109.962C36.7633 109.196 36.3094 108.572 35.7988 108.09L34.3521 110.047C35.4017 111.267 36.508 112.742 35.2882 114.359C34.4088 115.55 32.7919 115.947 30.8063 114.841ZM33.416 108.912L34.6074 107.267C33.8982 106.955 33.416 107.097 33.1323 107.494C32.8487 107.891 33.0189 108.373 33.416 108.912ZM33.3593 113.139C33.6429 112.742 33.4727 112.26 33.104 111.721L31.9409 113.309C32.5934 113.621 33.0756 113.508 33.3593 113.139Z",
    fill: "#EA9F26"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBuysell4);
export default __webpack_public_path__ + "static/media/buysell4.9b3135b962bd9ed92ad55ed035df680d.svg";
export { ForwardRef as ReactComponent };